import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../translation/translation';
import filterToCurrentSizes from './filter_to_current_sizes';
import { Filters } from '../../../../constants/filter/filters';

function SecondaryMissing(props) {
    const filters = props.filters;
    const sizes = filterToCurrentSizes(props.filters, props.displayDimensions);
    const onSizesClickParams = ["sizes"];
    
    if (!filters[Filters.SPEED_INDEX] || !filters[Filters.LOAD_INDEX]) {
        onSizesClickParams.push("indexes");
    }

    let currentStatusTranslationKey = 'catalog-current-status-missing-tyre-index-and-postcode';
    if (filters[Filters.SPEED_INDEX] && filters[Filters.LOAD_INDEX] && filters[Filters.POSTCODE]) {
        currentStatusTranslationKey = 'catalog-current-status-nothing-missing';
    }

    const hasRegion = !!filters.region;
    const hasPostcode = filters[Filters.POSTCODE] !== '';
    const showPostcode = hasPostcode || props.postcodeExistsButNeedsToBeLoaded;

    return (
        <span className="statusbar__current-status">
            <span className="statusbar__current-status-label">
                <Translation translationKey={currentStatusTranslationKey} className="statusbar__current-status-label-intro" />
                <span
                    className="statusbar__current-status-sizes statusbar__current-status-value"
                    onClick={() => props.onChange(onSizesClickParams)}
                >
                    { sizes }
                    <Translation translationKey="catalog-current-status-edit" className="statusbar__current-status-value-edit" />
                </span>

                {showPostcode &&
                    <Translation translationKey="catalog-current-status-in" />
                }
                {showPostcode &&
                    <span className="statusbar__current-status-postcode statusbar__current-status-value" onClick={() => props.onChange(["postcode"])}>
                        { hasRegion && filters.region }
                        { hasRegion && hasPostcode && ', '}
                        { hasPostcode && filters[Filters.POSTCODE] }
                        <Translation translationKey="catalog-current-status-edit" className="statusbar__current-status-value-edit" />
                    </span>
                }
            </span>
        </span>
    );
}

SecondaryMissing.propTypes = {
    filters: PropTypes.object.isRequired,
    postcodeExistsButNeedsToBeLoaded: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    displayDimensions: PropTypes.string,
};

SecondaryMissing.defaultProps = {
    displayDimensions: '',
};

export default SecondaryMissing;
